import type { UserInfo } from '../api/account';

export interface BillingSummary {
  /// Whether the account currently has plan access (server `active`, grace incl.).
  isPro: boolean;
  /// Display label — "Free" or e.g. "Pro · annual".
  planLabel: string;
  /// Formatted period-end date ("Jun 17, 2026"), or null when free / unknown.
  through: string | null;
}

/// Pure derivation of the billing card's display state from the user's
/// entitlement fields. Kept separate from the component so it's unit-testable.
export function billingSummary(
  user: Pick<UserInfo, 'active' | 'plan' | 'interval' | 'plan_expires_at'>,
): BillingSummary {
  if (!user.active) {
    return { isPro: false, planLabel: 'Free', through: null };
  }
  const term =
    user.interval === 'year' ? 'annual' : user.interval === 'month' ? 'monthly' : null;
  return {
    isPro: true,
    planLabel: term ? `Pro · ${term}` : 'Pro',
    through: formatDate(user.plan_expires_at),
  };
}

/// Format an ISO timestamp as a short local date, or null if absent/invalid.
export function formatDate(iso?: string | null): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
